<template>
  <div
    class="flex flex-col gap-4 px-5 pt-5 pb-8 transition-all duration-300 min-h-[500px]"
  >
    <a-divider orientation="left" orientation-margin="0px" class="!m-0">
      <span class="text-4xl font-semibold">{{ props.title }}</span>
    </a-divider>
    <div class="flex flex-col grow">
      <slot />
    </div>
    <hr class="mt-auto" />
    <div class="flex justify-center">
      <a-button type="primary" class="w-full max-w-sm" @click="props.onClick">
        {{ props.btnText }}
      </a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SuccessFrameProps } from "./type";
const props = defineProps<SuccessFrameProps>();
</script>
